(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    /*
    StickyCartBar — versione NATIVA (senza Globo).
    Pilota il variant picker del tema Wonder:
      <variant-options data-section="ID">
        <input type="radio" data-position="N" value="X" form="product-form-ID">
    Spuntare il radio + evento "change" (bubbles) fa partire variants.js, che aggiorna
    prezzo, URL e galleria (foto per colore).

    In piu' fa da "controllore" della pagina prodotto:
    - tiene l'id variante dei form allineato alla combinazione scelta;
    - attiva/disattiva il pulsante nativo "Aggiungi al carrello" (bug del tema: non lo faceva);
    - se data-hide-sold-out="true", nasconde i valori esauriti nel picker e nella sticky
      (gerarchico: il colore conta tutte le taglie, la taglia conta il colore scelto).
      Il colore scelto non viene mai cambiato d'ufficio; se un colore e' tutto esaurito
      si mostrano tutte le taglie come "esaurito" (resta raggiungibile l'avviso WhatsApp).
  */
  class StickyCartBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.dfSection;
      this.formId = this.dataset.formId;
      this.hasOnlyDefault = this.dataset.hasOnlyDefault === 'true';
      this.hideSoldOut = this.dataset.hideSoldOut === 'true';
      this.priceSourceSelector = this.dataset.priceSource;

      this.submitBtn = this.querySelector('[data-sticky-submit]');
      this.priceTarget = this.querySelector('[data-sticky-price]');
      this.notice = this.querySelector('[data-sticky-notice]');
      this.selects = Array.from(this.querySelectorAll('[data-sticky-option]'));
      this.placeholders = this.selects.map((s) => s.querySelector('option[value=""]'));
      this.masterValues = this.selects.map((s) =>
        Array.from(s.options).filter((o) => o.value !== '').map((o) => o.value)
      );

      this.variants = this.readVariants();
      this.syncing = false;
      this.ready = false;

      this.onScroll = this.onScroll.bind(this);
      this.onNativeChange = this.onNativeChange.bind(this);
      this.onSubmitClick = this.onSubmitClick.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      this.nativeBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      // Testi ufficiali del tema (window.variantStrings da theme.liquid), non quelli renderizzati
      const strings = window.variantStrings || {};
      this.labelAdd = (strings.addToCart || 'Aggiungi al carrello').trim();
      this.labelSoldOut = (strings.soldOut || 'Esaurito').trim();
      this.labelUnavailable = (strings.unavailable || 'Non disponibile').trim();

      this.bindSelects();
      if (this.submitBtn) this.submitBtn.addEventListener('click', this.onSubmitClick);

      // Cambi fatti sul picker in pagina (o lanciati dalla sticky)
      document.addEventListener('change', this.onNativeChange);

      // Prezzo: variants.js riscrive #price-ID dopo il fetch della sezione
      this.priceSource = document.querySelector(this.priceSourceSelector);
      if (this.priceSource && 'MutationObserver' in window) {
        this.priceObserver = new MutationObserver(() => this.updatePrice());
        this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
      }

      // Primo giro solo visivo; i cambi automatici di taglia partono quando il tema e' pronto
      // (picker + form), altrimenti variants.js va in errore.
      this.syncFromNative();
      this.updatePrice();
      const timeout = new Promise((resolve) => setTimeout(resolve, 4000));
      const themeReady = Promise.all([
        customElements.whenDefined('variant-options'),
        customElements.whenDefined('product-form'),
      ]);
      Promise.race([themeReady, timeout]).then(() => {
        this.ready = true;
        this.syncFromNative();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('change', this.onNativeChange);
      if (this.submitBtn) this.submitBtn.removeEventListener('click', this.onSubmitClick);
      if (this.priceObserver) this.priceObserver.disconnect();
    }

    readVariants() {
      const node = this.querySelector('[data-sticky-variants]');
      if (!node) return [];
      try { return JSON.parse(node.textContent); } catch (e) { return []; }
    }

    onScroll() {
      if (window.scrollY > 30) this.classList.add('is-visible');
      else this.classList.remove('is-visible');
    }

    /* ---------- Picker nativo ---------- */

    variantOptions() {
      return document.querySelector(`variant-options[data-section="${this.sectionId}"]`);
    }

    nativeRadios(position) {
      const vo = this.variantOptions();
      if (!vo) return [];
      return Array.from(vo.querySelectorAll(`input[type="radio"][data-position="${position}"]`));
    }

    positions() {
      return this.selects.map((s) => parseInt(s.dataset.stickyOption, 10)).sort((a, b) => a - b);
    }

    /* Valori scelti: dal picker nativo (fonte di verita'), altrimenti dalla sticky */
    nativeChosen() {
      const chosen = {};
      this.selects.forEach((s) => {
        const pos = parseInt(s.dataset.stickyOption, 10);
        const checked = this.nativeRadios(pos).find((r) => r.checked);
        chosen[pos] = checked ? checked.value : (s.value || null);
      });
      return chosen;
    }

    /* Disponibile = esiste una variante disponibile con questo valore
       e con le scelte delle opzioni PRECEDENTI (colore -> taglia) */
    isAvailable(pos, value, chosen) {
      return this.variants.some((v) => {
        if (!v.available || v.options[pos - 1] !== value) return false;
        for (let q = 1; q < pos; q++) {
          if (chosen[q] && v.options[q - 1] !== chosen[q]) return false;
        }
        return true;
      });
    }

    /* Spunta il radio nativo del valore scelto e fa partire variants.js */
    selectNative(position, value) {
      const radio = this.nativeRadios(position).find((r) => r.value === value);
      if (!radio || radio.checked) return false;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    /* Nasconde nel picker nativo i valori esauriti; se la taglia scelta e' esaurita
       passa alla prima disponibile. Ritorna true se ha cambiato una scelta. */
    applyHideSoldOut(chosen) {
      for (const pos of this.positions()) {
        const radios = this.nativeRadios(pos);
        const anyAvail = radios.some((r) => this.isAvailable(pos, r.value, chosen));
        radios.forEach((r) => {
          const li = r.closest('li');
          if (!li) return;
          const show = !anyAvail || this.isAvailable(pos, r.value, chosen) ||
            (r.value === chosen[pos] && (pos === 1 || !this.ready));
          li.style.display = show ? '' : 'none';
        });
        if (this.ready && pos > 1 && anyAvail && chosen[pos] && !this.isAvailable(pos, chosen[pos], chosen)) {
          const first = radios.find((r) => this.isAvailable(pos, r.value, chosen));
          if (first) {
            first.checked = true;
            first.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }
      }
      return false;
    }

    /* Ricostruisce le tendine della sticky (iOS ignora option[hidden], quindi si rimuovono) */
    rebuildSelects(chosen) {
      this.selects.forEach((select, i) => {
        const pos = parseInt(select.dataset.stickyOption, 10);
        const values = this.masterValues[i];
        const anyAvail = values.some((v) => this.isAvailable(pos, v, chosen));
        const keep = values.filter((v) =>
          !this.hideSoldOut || !anyAvail || this.isAvailable(pos, v, chosen) || v === chosen[pos]
        );
        select.innerHTML = '';
        if (this.placeholders[i]) select.appendChild(this.placeholders[i]);
        keep.forEach((v) => {
          const opt = document.createElement('option');
          const available = this.isAvailable(pos, v, chosen);
          opt.value = v;
          opt.textContent = available ? v : `${v} (esaurito)`;
          opt.disabled = !available && v !== chosen[pos];
          select.appendChild(opt);
        });
        select.value = keep.indexOf(chosen[pos]) !== -1 ? chosen[pos] : '';
      });
    }

    syncFromNative() {
      if (this.syncing) return;
      if (this.hasOnlyDefault) { this.updateState(); this.updateNativeButton(); return; }
      this.syncing = true;
      try {
        let chosen = this.nativeChosen();
        let guard = 0;
        while (this.hideSoldOut && guard++ < 3 && this.applyHideSoldOut(chosen)) {
          chosen = this.nativeChosen();
        }
        this.rebuildSelects(chosen);
        this.updateState();
        this.updateFormIds();
        this.updateNativeButton();
      } finally {
        this.syncing = false;
      }
    }

    onNativeChange(e) {
      const vo = this.variantOptions();
      if (!vo || !vo.contains(e.target)) return;
      this.syncFromNative();
    }

    bindSelects() {
      this.selects.forEach((select) => {
        select.addEventListener('change', () => {
          const pos = parseInt(select.dataset.stickyOption, 10);
          if (!this.selectNative(pos, select.value)) this.syncFromNative();
        });
      });
    }

    /* ---------- Stato ---------- */

    chosenValues() {
      const values = {};
      this.selects.forEach((s) => {
        values[parseInt(s.dataset.stickyOption, 10)] = s.value || null;
      });
      return values;
    }

    matchedVariant() {
      if (this.hasOnlyDefault) return this.variants[0] || null;
      const chosen = this.chosenValues();
      const allChosen = Object.values(chosen).every((v) => v);
      if (!allChosen) return null;
      return this.variants.find((v) =>
        Object.keys(chosen).every((posStr) => {
          const pos = parseInt(posStr, 10);
          return v.options[pos - 1] === chosen[pos];
        })
      ) || null;
    }

    showNotice(msg) {
      if (!this.notice) return;
      if (msg) { this.notice.textContent = msg; this.notice.hidden = false; }
      else { this.notice.hidden = true; }
    }

    updateState() {
      if (this.hasOnlyDefault) {
        const v = this.variants[0];
        this.submitBtn.disabled = !(v && v.available);
        this.showNotice(v && v.available ? null : 'Esaurito');
        return;
      }
      const allChosen = this.selects.every((s) => s.value !== '');
      if (!allChosen) { this.submitBtn.disabled = true; this.showNotice(null); return; }
      const variant = this.matchedVariant();
      if (!variant) { this.submitBtn.disabled = true; this.showNotice('Combinazione non disponibile'); }
      else if (!variant.available) { this.submitBtn.disabled = true; this.showNotice('Esaurito'); }
      else { this.submitBtn.disabled = false; this.showNotice(null); }
    }

    /* Id variante dei form (carrello + rate) sempre = combinazione scelta */
    updateFormIds() {
      const variant = this.matchedVariant();
      if (!variant) return;
      document
        .querySelectorAll(`#product-form-${this.sectionId} input[name="id"], #product-form-installment-${this.sectionId} input[name="id"]`)
        .forEach((input) => {
          if (String(input.value) !== String(variant.id)) input.value = variant.id;
        });
    }

    /* Pulsante nativo "Aggiungi al carrello": disattivato se esaurito */
    updateNativeButton() {
      const btn = this.nativeBtn;
      if (!btn) return;
      const variant = this.matchedVariant();
      const ok = !!(variant && variant.available);
      btn.disabled = !ok;
      btn.classList.toggle('df-sold-out', !ok);
      const span = btn.querySelector('span');
      if (span) span.textContent = ok ? this.labelAdd : (variant ? this.labelSoldOut : this.labelUnavailable);
    }

    /* Controllo finale: l'id nel form DEVE essere la variante scelta nella sticky */
    onSubmitClick(e) {
      const variant = this.matchedVariant();
      if (!variant || !variant.available) {
        e.preventDefault();
        e.stopPropagation();
        this.updateState();
        return;
      }
      const form = document.getElementById(this.formId);
      const input = form ? form.querySelector('input[name="id"]') : null;
      if (input && String(input.value) !== String(variant.id)) {
        input.value = variant.id;
      }
    }

    updatePrice() {
      if (!this.priceSource || !this.priceTarget) return;
      const sale = this.priceSource.querySelector('.price-item--sale');
      const regular = this.priceSource.querySelector('.price-item--regular');
      let text = '';
      if (sale && sale.offsetParent !== null) text = sale.textContent;
      else if (regular) text = regular.textContent;
      text = (text || '').trim();
      if (text) this.priceTarget.textContent = text;
    }
  }

  if (!customElements.get('sticky-cart-bar')) {
    customElements.define('sticky-cart-bar', StickyCartBar);
  }
  } catch(e) { console.error(e); }
})();

})();
